import { render, staticRenderFns } from "./RoomAdd.vue?vue&type=template&id=5836ab72&scoped=true"
import script from "./RoomAdd.vue?vue&type=script&lang=js"
export * from "./RoomAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5836ab72",
  null
  
)

export default component.exports